import './configure-webpack-path';
import $ from 'jquery';
// import * as pageHelpers from './page-helpers';

import '../elements/frontend';

export createLightbox from './lightbox';
export pinit from './pinterest';

export function pageHelper(helper) {
  return (...args) => {
    System.import(`./page-helpers/${helper}/index.js`)
      .then(module => {
        if (process.env.NODE_ENV === 'development') {
          console.warn('pageHelper: Loaded module', module)
        }
        return module
      })
      .then(module => module.default(...args))
      .catch(err => {
        console.error(err) // eslint-disable-line
        throw new Error(`Unknown page helper: ${helper}`)
      })
  }
}

/**
 * @param {string} script
 * @param {function} callback
 * @return {void}
 */
export function load(script, callback) {
  $.getScript(script, callback);
}

/**
 * Loads a JS file from within a symfony bundle
 * @param {string} bundle
 * @param {string} file
 * @param {function} callback
 * @return {void}
 */
export function bundleFile(bundle, file, callback) {
  const bundleName = bundle.replace('-', '')
  load(`/cms/bundles/blank${bundleName}/${file}`, callback)
}



// WEBPACK FOOTER //
// ./src/frontend/index.js